import moment from 'moment'
import 'moment/locale/ru'
import 'moment/locale/es'
import 'moment/locale/pt'
import 'moment/locale/fr'
import 'moment/locale/de'

import COOKIES from 'common/constants/cookies'

import { LOCALES, DEFAULT_LOCALE } from 'i18n/languages'

import { getCookie } from 'utils/cookies'

const userLng = getCookie(COOKIES.LOCALE) || DEFAULT_LOCALE

export const getMoment = moment

export const FORMATS = {
    dateTime: {
        [LOCALES.EN]: 'MMM D, YYYY (LT)',
        [LOCALES.RU]: 'D MMM YYYY (LT)',
        [LOCALES.ES]: 'MMM D, YYYY (LT)',
        [LOCALES.PT]: 'MMM D, YYYY (LT)',
        [LOCALES.FR]: 'MMM D, YYYY (LT)',
        [LOCALES.DE]: 'MMM D, YYYY (LT)',
    },
    date: {
        [LOCALES.EN]: 'MMM D, YYYY',
        [LOCALES.RU]: 'D MMM YYYY',
        [LOCALES.ES]: 'MMM D, YYYY',
        [LOCALES.PT]: 'MMM D, YYYY',
        [LOCALES.FR]: 'MMM D, YYYY',
        [LOCALES.DE]: 'MMM D, YYYY',
    },
    shortDate: {
        [LOCALES.EN]: 'MMM D',
        [LOCALES.RU]: 'D MMM',
        [LOCALES.ES]: 'MMM D',
        [LOCALES.PT]: 'MMM D',
        [LOCALES.FR]: 'MMM D',
        [LOCALES.DE]: 'MMM D',
    },
    shortCycle: {
        seconds: {
            [LOCALES.EN]: 'sec',
            [LOCALES.RU]: 'сек',
            [LOCALES.ES]: 'seg',
            [LOCALES.PT]: 'seg',
            [LOCALES.FR]: 'sec',
            [LOCALES.DE]: 'sec',
        },
        minutes: {
            [LOCALES.EN]: 'min',
            [LOCALES.RU]: 'мин',
            [LOCALES.ES]: 'min',
            [LOCALES.PT]: 'min',
            [LOCALES.FR]: 'min',
            [LOCALES.DE]: 'min',
        },
        hour: {
            [LOCALES.EN]: 'h',
            [LOCALES.RU]: 'ч',
            [LOCALES.ES]: 'h',
            [LOCALES.PT]: 'h',
            [LOCALES.FR]: 'h',
            [LOCALES.DE]: 'h',
        },
        day: {
            [LOCALES.EN]: 'day',
            [LOCALES.RU]: 'дней',
            [LOCALES.ES]: 'día',
            [LOCALES.PT]: 'dia',
            [LOCALES.FR]: 'jour',
            [LOCALES.DE]: 'tag',
        },
        weeks: {
            [LOCALES.EN]: 'weeks',
            [LOCALES.RU]: 'недель',
            [LOCALES.ES]: 'semanas',
            [LOCALES.PT]: 'semanas',
            [LOCALES.FR]: 'semaines',
            [LOCALES.DE]: 'wochen',
        },
    },
}

export const getDateTime = (timestamp, formats = FORMATS.dateTime, lng = userLng) => {
    let format = typeof formats === 'string' ? formats : formats[lng]
    return moment(timestamp).locale(lng).format(format)
}

export const getDate = (timestamp, formats = FORMATS.date, lng = userLng) => {
    return getDateTime(timestamp, formats, lng)
}

export const getShortDate = (timestamp, formats = FORMATS.shortDate, lng = userLng) =>
    getDateTime(timestamp, formats, lng)

const hour = 60 * 60
const day = hour * 24
const month = day * 30
const year = month * 12

const hourStrRepr = 'HOUR'
const dayStrRepr = 'DAY'
const monthStrRepr = 'MONTH'
const yearStrRepr = 'YEAR'

export const getTime = data => (data && data.getTime()) || new Date.getTime()

export const getTimeStep = (fromDate, toDate, formatAsNumber = true) => {
    const from = moment(fromDate)
    const to = moment(toDate)
    const diff = to.diff(from, 'days')

    if (diff <= 1) return formatAsNumber ? hour : hourStrRepr
    if (diff < 125) return formatAsNumber ? day : dayStrRepr // 125 days
    if (diff < 125 * 30) return formatAsNumber ? month : monthStrRepr // 125 month
    if (diff < 125 * 30 * 12) return formatAsNumber ? year : yearStrRepr // 125 years
    return formatAsNumber ? Math.round((toDate - fromDate) / 6000) : yearStrRepr
}
